import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getTodayTime, getMonthName } from '../util';
import dayjs from '../dayjs';
var ROW = 4;
var COL = 3;
var MonthTable = (function (_super) {
    __extends(MonthTable, _super);
    function MonthTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    MonthTable.getDerivedStateFromProps = function (props) {
        return props.value ? {
            value: props.value,
        } : null;
    };
    MonthTable.prototype.setAndSelectValue = function (value) {
        var onSelect = this.props.onSelect;
        this.setState({
            value: value,
        });
        onSelect(value);
    };
    MonthTable.prototype.chooseMonth = function (month) {
        var value = this.state.value;
        var next = value.clone();
        next.month(month);
        this.setAndSelectValue(next);
    };
    MonthTable.prototype.months = function () {
        var value = this.state.value;
        var current = value.clone();
        return Array.from({ length: ROW }).reduce(function (rows, _, rowIndex) {
            rows.push([]);
            Array.from({ length: COL }).reduce(function (cols, __, colIndex) {
                var index = rowIndex * COL + colIndex;
                current.month(index);
                var content = getMonthName(current);
                cols.push({
                    content: content,
                    value: index,
                    title: content,
                });
                return cols;
            }, rows.at(-1));
            return rows;
        }, []);
    };
    MonthTable.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var today = getTodayTime(value);
        var months = this.months();
        var currentMonth = value.month();
        var _a = this.props, cellRender = _a.cellRender, contentRender = _a.contentRender, disabledDate = _a.disabledDate, locale = _a.locale, prefixCls = _a.prefixCls;
        var monthsEls = months.map(function (month, index) {
            var tds = month.map(function (monthData) {
                var _a;
                var disabled = false;
                if (disabledDate) {
                    var testValue = value.clone();
                    testValue.month(monthData.value);
                    disabled = disabledDate(testValue);
                }
                var cellEl;
                if (cellRender) {
                    var currentValue = value.clone();
                    currentValue.month(monthData.value);
                    cellEl = cellRender(currentValue, locale);
                }
                else {
                    var content = void 0;
                    if (contentRender) {
                        var currentValue = value.clone();
                        currentValue.month(monthData.value);
                        content = contentRender(currentValue, locale);
                    }
                    else {
                        content = monthData.content;
                    }
                    cellEl = (h("span", { className: prefixCls + "-month" }, content));
                }
                return (h("td", { key: monthData.value, role: "gridcell", title: monthData.title, className: classnames(prefixCls + "-cell", (_a = {},
                        _a[prefixCls + "-cell-disabled"] = disabled,
                        _a[prefixCls + "-selected-cell"] = monthData.value === currentMonth,
                        _a[prefixCls + "-current-cell"] = today.year() === value.year() && monthData.value === today.month(),
                        _a)), onClick: disabled ? null : function () { return _this.chooseMonth(monthData.value); } }, cellEl));
            });
            return h("tr", { key: "" + index.toString(), role: "row" }, tds);
        });
        return (h("table", { cellSpacing: "0", className: prefixCls + "-table", role: "grid" },
            h("tbody", { className: prefixCls + "-tbody" }, monthsEls)));
    };
    return MonthTable;
}(Component));
MonthTable.propTypes = {
    onSelect: PropTypes.func.isRequired,
    cellRender: PropTypes.func,
    contentRender: PropTypes.func,
    disabledDate: PropTypes.func,
    locale: PropTypes.shape({}),
    prefixCls: PropTypes.string,
    value: PropTypes.instanceOf(dayjs),
};
MonthTable.defaultProps = {
    cellRender: undefined,
    contentRender: undefined,
    disabledDate: undefined,
    locale: {},
    prefixCls: '',
    value: undefined,
};
delete MonthTable.defaultProps.value;
export default MonthTable;
